import { fetch } from '../../plugin/axios'

export function getSalaryMonthList(data) {
  return fetch({
    url: '/app/salary/month/list',
    method: 'POST',
    data
  })
}

export function getSalaryMonthDetail(data) {
  return fetch({
    url: '/app/salary/month/detail',
    method: 'POST',
    data
  })
}

export function getSalaryMonthItemDetail(data) {
  return fetch({
    url: '/app/salary/month/item/detail',
    method: 'POST',
    data
  })
}
